"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NUMBER_INPUT_MIN_VALUE = exports.CounterInput = void 0;
var _react = _interopRequireDefault(require("react"));
var _ButtonIcon = require("b2b-components/theme/components/ButtonIcon");
var _common = require("b2b-components/theme/components/Form/common");
var _TextInput = require("b2b-components/theme/components/Form/TextInput");
var _Icon = require("b2b-components/theme/components/Icon");
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
var _Error = require("../common/Error");
require("./CounterInput.scss");
const NUMBER_INPUT_MIN_VALUE = exports.NUMBER_INPUT_MIN_VALUE = 1;
const CounterInput = _ref => {
  let {
    counterId,
    hasFocus,
    isDecreaseDisabled,
    isIncreaseDisabled,
    onBlur,
    onChange,
    onDecreaseClick,
    onFocus,
    onIncreaseClick,
    error = null,
    isDisabled = false,
    styleType = _common.STYLE_TYPE.outlined,
    value = NUMBER_INPUT_MIN_VALUE,
    className,
    buttonClassName,
    inputClassName
  } = _ref;
  const rootClass = (0, _classnames.default)('cds-CounterInput', `cds-CounterInput--${(0, _upperCase.upperCaseFirst)(styleType)}`, {
    'cds-Form-Input--Error': error,
    'cds-CounterInput--Disabled': isDisabled
  }, className);
  const inputClass = (0, _classnames.default)('cds-CounterInput-Quantity', {
    'cds-CounterInput-Quantity--Expanded': hasFocus
  });
  const buttonClass = (0, _classnames.default)(buttonClassName, 'cds-CounterInput-Button');
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: rootClass
  }, /*#__PURE__*/_react.default.createElement(_ButtonIcon.ButtonIcon, {
    icon: _Icon.ICON_NAME.minus,
    isDisabled: isDisabled || isDecreaseDisabled,
    onClick: onDecreaseClick,
    className: buttonClass,
    size: _ButtonIcon.BUTTON_ICON_SIZE.small,
    dataAttributes: {
      ['data-testid']: 'minusQtyButton'
    }
  }), /*#__PURE__*/_react.default.createElement(_TextInput.TextInput, {
    disabled: isDisabled,
    textInputId: counterId,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    styleType: styleType,
    value: value,
    className: inputClass,
    componentClassName: inputClassName
  }), /*#__PURE__*/_react.default.createElement(_ButtonIcon.ButtonIcon, {
    icon: _Icon.ICON_NAME.plus,
    isDisabled: isDisabled || isIncreaseDisabled,
    onClick: onIncreaseClick,
    className: buttonClass,
    size: _ButtonIcon.BUTTON_ICON_SIZE.small,
    dataAttributes: {
      ['data-testid']: 'plusQtyButton'
    }
  })), error && /*#__PURE__*/_react.default.createElement(_Error.Error, null, error));
};
exports.CounterInput = CounterInput;
//# sourceMappingURL=CounterInput.js.map